import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const holidayCalendarAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'holidayCalendarAPI',
    endpoints: (builder) => ({

        addHoliday: builder.mutation({
            query: (data) => ({
                url: '/holiday',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateHoliday: builder.mutation({
            query: (data) => ({
                url: `/holiday/${data.holidayId}`,
                method: 'PUT',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getListHoliday: builder.query({
            query: ({ page = 0, size = 10, searchText = '', sortDir = 'asc', isUpcomingFlag } = {}) => ({
                url: `/holiday`,
                method: 'GET',
                params: {
                    page, size, ...(searchText && { searchText }), ...(sortDir && { sortDir }),
                    ...(isUpcomingFlag && { isUpcomingFlag })
                }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getHolidayById: builder.query({
            query: (holidayId) => ({
                url: `/holiday/${holidayId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteHoliday: builder.mutation({
            query: (holidayId) => ({
                url: `/holiday/${holidayId}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        exportHolidayExcel: builder.query({
            query: () => ({
                url: `/holiday/excel`,
                method: 'GET',
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `holiday_calendar.xlsx`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    return { success: true };
                },
                cache: 'no-cache',
            }),
            transformErrorResponse: transformErrorResponse
        }),

    })
});

export const {
    useAddHolidayMutation, useUpdateHolidayMutation,
    useLazyGetHolidayByIdQuery,
    useLazyGetListHolidayQuery, useDeleteHolidayMutation,
    useLazyExportHolidayExcelQuery
} = holidayCalendarAPI;

export default holidayCalendarAPI;
